export function banksReducer(state = "" ,{
    type,
    payload
}){
    
    switch(type){
        case "NEW_BANK":            
        case "UPDATE_BANK":
            let list = Object.assign({}, state);
            list[payload.bank_id] = payload
        
            return list
            
        case "GET_BANKS":

            return payload
    
        default:
            return state;
    }
    
}